import React, { useState } from 'react';
import { getToken } from '../../auth/authService';

const CompleteProfile = () => {
  const [form, setForm] = useState({ fullName: '', phone: '', email: '' });
  const [message, setMessage] = useState('');

  const handleSubmit = async e => {
    e.preventDefault();
    const token = getToken();
    const res = await fetch('/api/user/complete-profile', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(form),
    });
    if (res.ok) {
      setMessage('Profile saved. Redirecting...');
      setTimeout(() => window.location.href = '/dashboard', 1000);
    } else {
      setMessage('Error saving profile');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded shadow-md w-full max-w-lg">
        <h2 className="text-xl font-bold mb-6 text-center">Complete Your Profile</h2>
        {message && <div className="text-green-600 mb-4 text-sm">{message}</div>}
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            className="w-full p-2 border rounded"
            placeholder="Full Name"
            onChange={e => setForm({ ...form, fullName: e.target.value })}
          />
          <input
            className="w-full p-2 border rounded"
            placeholder="Phone"
            onChange={e => setForm({ ...form, phone: e.target.value })}
          />
          <input
            className="w-full p-2 border rounded"
            placeholder="Email"
            onChange={e => setForm({ ...form, email: e.target.value })}
          />
          <button
            type="submit"
            className="w-full bg-green-600 text-white py-2 rounded hover:bg-green-700"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default CompleteProfile;